/**
 * Numeric Input Plugin
 * modify basic text inputs into rich numeric inputs
 */

var NumericInput = function(element, options){
    this.element = element;
    this.$element = $(element);
    this.settings = $.extend({}, this.defaults, options);
    this.init();
};

NumericInput.prototype = {

    // shorthand for using prototype
    constructor : NumericInput,

    // default options
    defaults : {
        scope : document,
        allowZero : false,
        minValue : null,
        maxValue : null,
        increment : 1,
        onChange : function(value){}
    },

    init : function(){
        var _this = this,
            _id = _this.$element.attr('id'),
            _AutoNumericInstance = AutoNumeric.getAutoNumericElement(document.getElementById(_id)),
            defaultOptions = { modifyValueOnWheel: false },
            options = {};

        if ( _AutoNumericInstance == null ){
            if ( _this.$element.hasClass('currency') || _this.$element.hasClass('currency-input') ){
                options = {
                    minimumValue: 0
                };
            } else if ( _this.$element.hasClass('decimal-percentage-format') ) {
                options = {
                    digitGroupSeparator: '',
                    decimalPlaces: 2,
                    minimumValue: 0,
                    maximumValue: 100
                };
            } else if ( _this.$element.hasClass('percentage-format') ) {
                options = {
                    digitGroupSeparator: '',
                    decimalPlaces: 0,
                    maximumValue: 100,
                    minimumValue: 0
                };
            } else {
                options = {
                    digitGroupSeparator: '',
                    decimalPlaces: 0,
                    minimumValue: 0
                };
            }

            //merge custom options with defaults
            options = $.extend({}, defaultOptions, options);

            // init
            _AutoNumericInstance = new AutoNumeric(('#' + _id), options);
        }

        // render the custom controls
        _this.renderControls();

        // handle change callback
        _this.$element.on('blur', function(){
            var value = $(this).val();
            _this.settings.onChange.call(_this, value);
        });

        // bind increment/decrement functionality
        _this.$element.closest('.numeric-text-wrap').on('click', '.numeric-control', function(e) {
            const $parent = $(this).closest('.numeric-text-wrap');
            const $input = $parent.find('.form-field');
            const $unlimited = $(this).closest('.field-with-button-container').find('.ui-numeric-toggle-unlimited');
            const _max = $parent.find('.ui-numeric-text').attr('data-v-max') || _this.settings.maxValue;
            let inputValue = $input.val();
            let _value = 0;

            if (inputValue !== "") {
                inputValue = inputValue.replace(/,/g, '');
                _value = parseFloat(inputValue);
            }

            if ( ! $input.prop('disabled') ) {
                if ( $(this).hasClass('increment') ) {
                    // sometimes the field is cloned so we need to make sure it has a value first
                    if ( _AutoNumericInstance.getNumericString() === '' ) {
                        _AutoNumericInstance.set(1);
                        $input.trigger('blur');
                    }
                    // next make sure there isn't a limit or if there is, make sure we don't exceed it
                    if ( ! _max || _max && (_value < _max) ) {
                        _value = _value + _this.settings.increment;
                        _AutoNumericInstance.set(_value);
                        $input.trigger('blur');
                        $unlimited.prop('checked', false);
                    }
                } else if ( $(this).hasClass('decrement') ) {
                    _value = _value - _this.settings.increment;

                    // make sure we don't go less than 0 or the minimum
                    let minimum = 0;
                    if (_this.settings.minValue) {
                        minimum = _this.settings.minValue;
                    }
                    if ( _value < minimum ){
                        _value = minimum;
                    } else if ( _this.settings.minValue !== null && _value < _this.settings.minValue ) {
                        _value = _this.settings.minValue;
                    }

                    // Update input
                    // wrapped in try catch as decrementing to a value below the minValue
                    // causes a troublesome uncaught error resulting in screen jump
                    try { 
                        _AutoNumericInstance.set(_value)
                    } catch(e){
                        console.log(e)
                    }
                    
                    $input.trigger('blur');

                    if ( _value == 0 && ! _this.settings.allowZero ){ // if we do, trigger infinite
                        $unlimited.prop('checked', true).trigger('change');
                    }
                }
            }

            e.preventDefault();
        });

        // if we don't allow zero, the input should toggle unlimited when we hit 0
        if ( ! _this.settings.allowZero ){
            _this.$element.on('change', function(){
                var $unlimited = $(this).closest('.field-with-button-container').find('.ui-numeric-toggle-unlimited'),
                    _value = parseFloat($(this).val());

                if ( _value == 0 ){
                    $unlimited.prop('checked', true).trigger('change');
                }
            });
        }

        // bind unlimited functionality
        _this.$element.closest('.field-with-button-container').off('change').on('change', '.ui-numeric-toggle-unlimited', function(e) {
            var $parent = $(this).closest('.field-with-button-container');

            // Check explicitly to account for UI.clearFields
            if ( $(this).prop('checked') ) {
                $parent.addClass('active unlimited');
            } else {
                $parent.removeClass('active unlimited');
            }

            // check if we should set it to 1
            if ( _this.$element.val() == 0 && ! _this.settings.allowZero ){
                _AutoNumericInstance.set(1);
            }
        });

    },

    renderControls : function(){
        var _this = this,
            _id = _this.$element.attr('id'),
            _AutoNumericInstance = AutoNumeric.getAutoNumericElement(document.getElementById(_id));

        _this.$element.each(function() {
            var incrementIcon = $(this).attr('data-increment-icon'),
                decrementIcon = $(this).attr('data-decrement-icon');

            if ( $(this).val() === '' && !_this.settings.emptyInputBehavior ) {
                _AutoNumericInstance.set(1);
            }

            if ( $(this).closest('.numeric-text-wrap').length == 0 ) {
                $(this).wrap('<div class="numeric-text-wrap" />')
                    .after('<span><a class="ui-icon numeric-control increment" href="#" tabindex="-1">' + incrementIcon + '</a><a class="ui-icon numeric-control decrement" href="#" tabindex="-1">' + decrementIcon + '</a></span>');
            }
        });
    },

    destroy: function() {
        var _this = this;

        // unbind listeners
        _this.$element.off();
        _this.$element.closest( '.numeric-text-wrap' ).off();
        _this.$element.closest( '.field-with-button-container' ).off();

        // remove elements created by plugin
        _this.$element.find( '.numeric-control' ).parent().remove();
        $( _this ).unwrap();

        // remove stored data from jQuery element
        _this.$element.removeData( 'qg_numeric_input' );
    }

};

$.fn.numericInput = function ( options ) {
    this.each(function() {
        if ( !$.data( this, "qg_numeric_input" ) ) {
            $.data( this, "qg_numeric_input", new NumericInput( this, options ) );
        }
    });

    // chain jQuery functions
    return this;
};
